var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8,16c-0.7,0-1.6-0.3-2.7-0.9c-1.6-0.9-3.4-2.3-5.2-4.1c-1.7-1.7-3.2-3.6-4-5.1c-1-1.8-1.1-3.1-0.5-3.7 L1.8,1c0.4-0.3,0.8-0.5,1.3-0.4c0.5,0,0.9,0.3,1.2,0.6l1.4,1.6c0.5,0.6,0.6,1.5,0.1,2.1L5.4,5.6c-0.2,0.3-0.2,0.7,0.1,1l4,4 c0.3,0.3,0.7,0.3,1,0.1l0.7-0.4c0.7-0.4,1.5-0.4,2.1,0.1l1.6,1.4c0.4,0.3,0.6,0.7,0.6,1.2c0,0.5-0.1,0.9-0.4,1.3l-1.1,1.3 C13.6,15.9,13.2,16,12.8,16z M2.9,1.5c-0.2,0-0.4,0.1-0.5,0.2L1.1,2.8C0.8,3.1,0.9,4,1.7,5.4c0.8,1.5,2.2,3.3,3.9,4.9 c1.7,1.7,3.4,3.1,5,3.9c1.7,0.9,2.4,0.9,2.6,0.7l1.1-1.3c0.1-0.2,0.2-0.4,0.2-0.6s-0.1-0.4-0.3-0.5l-1.6-1.4 c-0.3-0.2-0.7-0.3-1-0.1L11,11.5c-0.7,0.5-1.6,0.4-2.2-0.2l-4-4C4.2,6.7,4.1,5.7,4.6,5L5,4.4c0.2-0.3,0.2-0.7-0.1-1L3.5,1.8l0,0 C3.4,1.6,3.2,1.5,2.9,1.5C3,1.5,2.9,1.5,2.9,1.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.9,7.5c-0.3,0-0.5-0.2-0.5-0.5c0-2-1.6-3.7-3.7-3.7c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5 c2.6,0,4.6,2.1,4.6,4.6C13.4,7.2,13.2,7.5,12.9,7.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,7.2C15.2,7.2,15,7,15,6.7C15,3.5,12.5,1,9.3,1C9,1,8.8,0.8,8.8,0.5S9,0,9.3,0C13,0,16,3,16,6.7 C16,7,15.8,7.2,15.5,7.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.dab44c872665825a4f1ccdf48aa192da.svg";
export { ForwardRef as ReactComponent };